// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2g3Gu","header":"ReportDetails_header__1SkSe","title":"ReportDetails_title__1tbzG","left":"ReportDetails_left__2PJQL"};